import React from 'react';

const HomeHealth: React.FC = () => {
    return (
        <div style={{
            minHeight: '100vh',
            background: 'white',
            color: '#4a306d',
            fontFamily: 'Arial, sans-serif'
        }}>
            {/* Hero Section */}
            <section style={{
                textAlign: 'center',
                padding: '0',
                background: 'transparent',
                minHeight: '100vh',
                display: 'flex',
                alignItems: 'center'
            }}>
                <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '2rem', width: '100%' }}>
                    {/* Logo */}
                    <div style={{ marginBottom: '1.5rem' }}>
                        <img
                            src="/tdl-logo.jpg"
                            alt="TDL Coaching & Consulting"
                            style={{
                                height: '100px',
                                maxWidth: '500px',
                                width: 'auto',
                                objectFit: 'contain',
                                borderRadius: '8px'
                            }}
                        />
                    </div>

                    <h1 className="hero-title" style={{
                        color: '#4a306d'
                    }}>
                        ⭐ Launch a Healthcare Career from Home
                    </h1>
                    <h2 className="hero-subtitle" style={{
                        color: '#4a306d',
                        fontSize: '1.8rem',
                        marginBottom: '1rem'
                    }}>
                        Become a Certified Home Health Aide HHA!
                    </h2>
                    <h3 className="hero-subtitle" style={{
                        color: '#6b6b6b'
                    }}>
                        Online, Affordable, Purpose-Driven: HHA Training You Can Start Today
                    </h3>
                    <h4 className="hero-subtitle" style={{
                        color: '#6b6b6b'
                    }}>
                        Turn Your Compassion into a Career – Enroll in HHA Training Now!
                    </h4>

                    {/* Two Column Layout for Price and Video */}
                    <div className="hero-grid">
                        {/* Left Column - Price and CTA */}
                        <div style={{ textAlign: 'center' }}>
                            <div style={{
                                fontSize: '1.5rem',
                                color: '#34a8a8',
                                fontWeight: 'bold',
                                marginBottom: '0.5rem'
                            }}>
                                💥 Enroll Today — Save $40!
                            </div>
                            <div style={{
                                fontSize: '2rem',
                                color: '#34a8a8',
                                fontWeight: 'bold',
                                marginBottom: '1rem'
                            }}>
                                Only $59.99
                            </div>
                            <div style={{
                                fontSize: '1rem',
                                color: '#34a8a8',
                                marginBottom: '1.5rem'
                            }}>
                                Normally $99 — now only $59.99 for the next 30 days!
                            </div>
                            <a
                                href="https://www.tdlcoaching.com/challenge-page/4fc0fe55-cdc5-42e8-a155-3578341cb1c4?programId=4fc0fe55-cdc5-42e8-a155-3578341cb1c4"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                    background: '#34a8a8',
                                    color: 'white',
                                    padding: '0.8rem 1.5rem',
                                    textDecoration: 'none',
                                    borderRadius: '50px',
                                    fontSize: '1.1rem',
                                    fontWeight: 'bold',
                                    display: 'inline-block',
                                    boxShadow: '0 4px 15px rgba(52, 168, 168, 0.4)',
                                    transition: 'all 0.3s ease'
                                }}
                            >
                                ➡️ ENROLL NOW for $59.99
                            </a>
                            <div style={{
                                marginTop: '1rem',
                                fontSize: '1rem',
                                fontWeight: 'bold',
                                color: '#34a8a8'
                            }}>
                                � PSecure your spot and gain instant access to all course materials.
                            </div>
                            <div style={{
                                marginTop: '1rem',
                                fontSize: '0.9rem',
                                color: '#6b6b6b'
                            }}>
                                (Hit the link above to sign up today and start learning immediately!)
                            </div>
                        </div>

                        {/* Right Column - Video */}
                        <div style={{
                            maxWidth: '100%'
                        }}>
                            <div style={{
                                position: 'relative',
                                paddingBottom: '56.25%',
                                height: 0,
                                overflow: 'hidden',
                                borderRadius: '15px',
                                boxShadow: '0 8px 25px rgba(0, 0, 0, 0.3)',
                                background: '#000'
                            }}>
                                <iframe
                                    src="https://www.youtube.com/embed/9v7573hNVHE"
                                    title="Home Health Aide Training Video"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                    allowFullScreen
                                    style={{
                                        position: 'absolute',
                                        top: 0,
                                        left: 0,
                                        width: '100%',
                                        height: '100%',
                                        borderRadius: '15px',
                                        border: 'none'
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Why Home Health Section */}
            <section style={{ padding: '4rem 0', background: 'transparent' }}>
                <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 0px' }}>
                    <h3 style={{
                        fontSize: '2.5rem',
                        textAlign: 'center',
                        marginBottom: '2rem',
                        color: '#34a8a8'
                    }}>
                        ■ Why Choose TDL Coaching, Consulting & Training Academy?
                    </h3>
                    <div style={{
                        background: 'rgba(240, 240, 240, 0.5)',
                        padding: '2rem',
                        borderRadius: '15px',
                        lineHeight: '1.6',
                        marginBottom: '3rem'
                    }}>
                        <p style={{ marginBottom: '1rem' }}>
                            At TDL Coaching, Consulting & Training Academy, we've made it easier than ever to start a meaningful healthcare career — right from home!
                            Our Home Health Aide (HHA) certification course is designed for busy individuals who want flexible, affordable training that leads to real job opportunities.
                        </p>

                        <h4 style={{ color: '#34a8a8', marginBottom: '1rem' }}>🎯 Program Highlights</h4>
                        <ul style={{ marginLeft: '1rem', marginBottom: '1rem' }}>
                            <li>⏰ Self-Paced Learning – Study anytime, anywhere</li>
                            <li>🏅 Certificate Included – Show employers you're job-ready</li>
                            <li>⚡ Complete in Just 2–4 Weeks!</li>
                            <li>🏠 Work in Clients' Homes or Assisted Living Facilities (ALF)</li>
                            <li>💰 Affordable Tuition — Only $59.99!</li>
                        </ul>

                        <h4 style={{ color: '#34a8a8', marginBottom: '1rem' }}>❤️ What Is a Home Health Aide (HHA)?</h4>
                        <p style={{ marginBottom: '1rem' }}>
                            A Home Health Aide is a compassionate professional who helps individuals live safely and comfortably at home.
                            You'll assist with daily activities such as:
                        </p>
                        <ul style={{ marginLeft: '1rem', marginBottom: '1rem' }}>
                            <li>Bathing, grooming, and dressing</li>
                            <li>Light meal preparation</li>
                            <li>Companionship and emotional support</li>
                            <li>Light housekeeping</li>
                        </ul>
                        <p>
                            Make a real impact every day — helping others live with dignity and independence.
                        </p>
                    </div>

                    <h3 style={{
                        fontSize: '2.5rem',
                        textAlign: 'center',
                        marginBottom: '3rem',
                        color: '#34a8a8'
                    }}>
                        � HHA vs. 'CNA: What's the Difference?
                    </h3>

                    <div style={{
                        background: 'rgba(240, 240, 240, 0.5)',
                        padding: '2rem',
                        borderRadius: '15px',
                        marginBottom: '3rem'
                    }}>
                        <div style={{
                            display: 'grid',
                            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
                            gap: '2rem',
                            textAlign: 'left'
                        }}>
                            <div>
                                <h4 style={{ color: '#34a8a8', marginBottom: '1rem' }}>HHA (Home Health Aide)</h4>
                                <p><strong>Training Length:</strong> 2–4 weeks</p>
                                <p><strong>Work Setting:</strong> Home care / ALF</p>
                                <p><strong>Focus:</strong> Personal & emotional support</p>
                                <p><strong>Flexibility:</strong> High (self-paced, remote-friendly)</p>
                            </div>
                            <div>
                                <h4 style={{ color: '#34a8a8', marginBottom: '1rem' }}>CNA (Certified Nursing Assistant)</h4>
                                <p><strong>Training Length:</strong> 6–12 weeks</p>
                                <p><strong>Work Setting:</strong> Hospitals / Nursing homes</p>
                                <p><strong>Focus:</strong> Clinical & medical care</p>
                                <p><strong>Flexibility:</strong> In-person, structured</p>
                            </div>
                        </div>
                    </div>

                </div>
            </section>


            {/* Final CTA */}
            <section style={{
                padding: '4rem 0',
                background: 'linear-gradient(135deg, #34a8a8, #4a306d)',
                textAlign: 'center'
            }}>
                <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 20px' }}>
                    <h3 style={{
                        fontSize: '2.5rem',
                        marginBottom: '1rem',
                        color: 'white'
                    }}>
                        💥 Enroll Today — Save $40!
                    </h3>
                    <p style={{
                        fontSize: '1.2rem',
                        marginBottom: '2rem',
                        opacity: 0.95,
                        color: 'white'
                    }}>
                        Normally $99 — now only $59.99 for the next 30 days!
                    </p>
                    <a
                        href="https://www.tdlcoaching.com/challenge-page/4fc0fe55-cdc5-42e8-a155-3578341cb1c4?programId=4fc0fe55-cdc5-42e8-a155-3578341cb1c4"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                            background: 'white',
                            color: '#4a306d',
                            padding: '1.5rem 3rem',
                            textDecoration: 'none',
                            borderRadius: '50px',
                            fontSize: '1.3rem',
                            fontWeight: 'bold',
                            display: 'inline-block',
                            boxShadow: '0 6px 20px rgba(0, 0, 0, 0.3)',
                            transition: 'all 0.3s ease',
                            marginBottom: '1rem'
                        }}
                    >
                        ➡️ Enroll Now
                    </a>
                </div>
            </section>


        </div>
    );
};

export default HomeHealth;